<template>
  <div class="header">
    <div class="left title">
      <img src="@/assets/logo.png" alt="">
      <span>电子文档加密系统</span>
    </div>
    <div class="left navbar">
      <slot name="nav"></slot>
    </div>
    <div class="right infobar">
      <slot name="info"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Header',
  data () {
    return {
      hasBtn: this.hasAccountBtn,
      status: true
    }
  },
  props: {
    hasAccountBtn: Boolean
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
  @import "@/common/theme/myTheme.scss";
  .left {
    float: left;
  }
  .header {
    height: 64px;
    background: $lightBlue;
    .title {
      width: 210px;
      img {
        margin: 19px 20px;
        float: left;
      }
      span {
        display: inline-block;
        font-size: 18px;
        line-height: 26px;
        margin: 19px 0;
        color: #fff;
      }
    }
    .navbar {
      color: #fff;
      margin-left: 50px;
      font-size: 0;
      span {
        width: 100px;
        text-align: center;
        display: inline-block;
        font-size: 18px;
        line-height: 26px;
        padding: 19px 0;
        color: #fff;
        background: $lightBlue;
        &:hover {
          cursor: pointer;
        }
      }
      .active {
        background: $deepBlue;
      }
    }
    .infobar {
      .date {
        height: 64px;
        text-align: center;
        margin-right: 20px;
        span {
          display: inline-block;
          margin: 23px 0;
          height: 26px;
          color: #fff;
        }
      }
      .login {
        height: 64px;
        text-align: center;
        margin-right: 20px;
        &:hover {
          cursor: pointer;
        }
        span {
          display: inline-block;
          margin: 19px 0;
          width: 60px;
          height: 26px;
          color: #fff;
        }
      }
      .user {
        height: 64px;
        text-align: center;
        margin-right: 20px;
        span {
          display: inline-block;
          margin: 19px 0;
          height: 26px;
          color: #fff;
          &:hover {
            cursor: pointer;
          }
        }
      }
      .help {
        height: 64px;
        text-align: center;
        margin-right: 20px;
        span {
          display: inline-block;
          margin: 19px 0;
          // width: 60px;
          height: 26px;
          color: #fff;
          &:hover {
            cursor: pointer;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue